import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.logo}>AB</div>
          <h1 style={styles.title}>AB Book System</h1>
          <p style={styles.subtitle}>Hybrid Routing Engine</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          <div style={styles.inputGroup}>
            <label style={styles.label}>아이디</label>
            <input
              style={styles.input}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              required
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>비밀번호</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button style={loading ? { ...styles.button, opacity: 0.7 } : styles.button} type="submit" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Pretendard', -apple-system, sans-serif",
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '20px',
    padding: '48px',
    width: '400px',
    boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
  },
  header: { textAlign: 'center', marginBottom: '36px' },
  logo: {
    width: '64px', height: '64px', background: 'linear-gradient(135deg, #667eea, #764ba2)',
    borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '24px', fontWeight: 800, color: '#fff', margin: '0 auto 16px',
    boxShadow: '0 8px 24px rgba(102,126,234,0.4)',
  },
  title: { color: '#fff', fontSize: '24px', fontWeight: 700, margin: '0 0 4px' },
  subtitle: { color: 'rgba(255,255,255,0.4)', fontSize: '13px', margin: 0 },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  error: {
    background: 'rgba(255,77,77,0.15)', border: '1px solid rgba(255,77,77,0.3)',
    borderRadius: '8px', padding: '12px', color: '#ff6b6b', fontSize: '13px', textAlign: 'center',
  },
  inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
  label: { color: 'rgba(255,255,255,0.6)', fontSize: '13px', fontWeight: 500 },
  input: {
    background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '10px', padding: '12px 16px', color: '#fff', fontSize: '14px',
    outline: 'none', transition: 'border-color 0.2s',
  },
  button: {
    background: 'linear-gradient(135deg, #667eea, #764ba2)', border: 'none',
    borderRadius: '10px', padding: '14px', color: '#fff', fontSize: '15px',
    fontWeight: 600, cursor: 'pointer', marginTop: '8px',
    boxShadow: '0 8px 24px rgba(102,126,234,0.4)', transition: 'transform 0.2s',
  },
};

export default LoginPage;
